export default "__VITE_ASSET__BxkQlh0I__"